import type { NavErrorBoundaryConfig } from '../../../ui/types';
import { getMessagesForLocation } from '../get-messages-for-location';

interface Props extends Pick<
	NavErrorBoundaryConfig,
	'errorMessages' | 'errorMessageValues' | 'location'
> {}

export function getMessages({
	errorMessages,
	errorMessageValues,
	location,
}: Props): Record<string, any> {
	return errorMessages
		? {
				header: errorMessages.header,
				description: errorMessages.description,
				values: errorMessageValues,
			}
		: getMessagesForLocation(location);
}
